module.exports = __webpack_public_path__ + "images/greenlab-97ace9cb4e2683ffd2bb770de9e70b07.jpg";